import { createRouter, createWebHistory } from 'vue-router'
import Login from '../components/Login.vue'
import HelloWorld from '../components/HelloWorld.vue'
import ApkList from '../components/ApkList.vue'
import AppMonitor from '../components/AppMonitor.vue'
import IssueDetail from '../components/IssueDetail.vue'
import ApiMonitor from '../components/ApiMonitor.vue'

// 获取Cookie
function getCookie(name) {
  const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${name}=`))
  return cookieValue ? cookieValue.split('=')[1] : null
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld,
    meta: { requiresAuth: true }
  },
  {
    path: '/apk-list',
    name: 'ApkList',
    component: ApkList,
    meta: { requiresAuth: true }
  },
  {
    path: '/app-monitor',
    name: 'AppMonitor',
    component: AppMonitor,
    meta: { requiresAuth: true }
  },
  {
    path: '/app-monitor/issue-detail',
    name: 'IssueDetail',
    component: IssueDetail,
    meta: { requiresAuth: true }
  },
  {
    path: '/api-monitor',
    name: 'ApiMonitor',
    component: ApiMonitor,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 检查是否有token
  const token = getCookie('token')
  
  // 如果用户已登录（有token）且尝试访问登录页面，重定向到首页
  if (to.name === 'Login' && token) {
    next({ name: 'Home' })
  }
  // 检查路由是否需要认证
  else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      // 没有token，重定向到登录页面
      next({ name: 'Login' })
    } else {
      // 有token，允许访问
      next()
    }
  } else {
    // 不需要认证的路由，直接通过
    next()
  }
})

export default router